import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { Navbar, NavDropdown, Nav, Dropdown, NavItem } from "react-bootstrap";
import { NavLink, withRouter } from "react-router-dom";
import {
  toggleSidebar,
  clearPermissionsList,
  getPermissionsAction
} from "../actions/common.action";
import { Logo, LogoSvgWhite } from ".";
import {
  getLocalstorage,
  scrollToPosition,
  isValidArray,
  PERMISSIONS_BY_MODULE,
  isAuthenticated
} from "../helper";
import { _userLogout } from "../actions/login.action";
import { Link } from "react-router-dom";
import IconHelpline from "../assets/icon-helpline.svg";
import IconNotification from "../assets/icon-notification.svg";
import LoaderGif from "../assets/pmiic_Loader.gif";
import { PATHS, STATUS } from "../constant";
import Notification from "../container/notification/Notification";
import {
  getDashboardNotifications,
  getNotificationUpdates
} from "../actions/dashboard.action";
import { get } from "lodash";
import DisplayByPermission from "./DisplayByPermission";
import pmgUser from "./../assets/user.jpg";
import { Container, Row, Image } from "react-bootstrap";
import ZoomLevelProvider from "../container/projectList/ZoomLevelProvider";
import GoiLogoResponsive from "../assets/goi_logo_responsive.png";
import NeedHelpModal from "../container/front/NeedHelpModal";
import { NotificationToggle } from "../container/notificationToggle";
import { getDashboardNotificationsAllViewed } from "../actions/dashboard.action";
import { getUserManualAction } from "../actions/dowloadExcelActions";
import { LoaderPage, NotificationLoaderPage } from "./Loader";
import ARlogo from "../assets/AR_logo.svg";
import GOIlogo from "../assets/GOI_L.png";
import GOIlogoalt from "../assets/Government_of_India_logo.png";
import axios from "axios";
import { getUpcommingAgendaFlagAction } from "../actions/pragati.action";
import upcomming_pragati_flagIcon from "../assets/upcomming_pragati_flagIcon.svg";
import satyamev from "../assets/satyamev.png";
import { getLandingPageNotifications } from "../services/apiServices";
import request from "../services/requestService";
import { getBestPracticesCountForHome } from "../actions/userManagement.action";
export class HeaderComponent extends Component {
  permissions = null;
  inactivityTimer;
  INACTIVITY_TIMEOUT = 240 * 60 * 1000;
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: !!getLocalstorage("token"),
      isNotificationWatched: !!getLocalstorage("isNotificationWatched"),
      notificationOpen: false,
      addHeaderClass: "",
      scrollMenu: {
        home: true,
        "how-it-works": false,
        features: false,
        projects: false,
        faq: false
      },
      scrollMenuArray: [],
      isOpen: false,
      isNotificationToggle: false,
      isMobile: false,
      expand: false,
      isModalVisible: false,
      modalContent: "",
      loaderDisplay: false,
      notifications: [],
      bestPracticesTotalCount: 0,
      zoomPercentage: 100,
      isOverviewOpen: false
    };
  }
  handleOverviewPanel = type => {
    if (type === "mouseEnter") {
      this.setState({ isOverviewOpen: true });
    } else if (type === "mouseLeave") {
      this.setState({ isOverviewOpen: false });
    } else {
      // click/toggle (mobile)
      this.setState(prev => ({ isOverviewOpen: !prev.isOverviewOpen }));
    }
  };
  handleZoomChange = zoom => {
    this.setState({ zoomPercentage: zoom });
  };
  width = zoomPercentage => {
    if (zoomPercentage <= 100) {
      return 125;
    } else {
      return 100;
    }
  };
  notificationClick = () => {
    const { notificationOpen } = this.state;
    const { getDashboardNotifications, getNotificationUpdates } = this.props;
    this.setState(
      () => ({
        notificationOpen: !notificationOpen
      }),
      async () => {
        await getDashboardNotificationsAllViewed();
        await getDashboardNotifications(undefined, { offset: 0, limit: 20 });
        getNotificationUpdates();
      }
    );
  };

  logOutUser = () => {
    let { _userLogout } = this.props;
    const refreshToken = getLocalstorage("refreshToken");
    const payload = {
      refreshToken: refreshToken
    };
    _userLogout(undefined, payload).then(resp => {
      if (resp) {
        window.localStorage && localStorage.clear();
        window.sessionStorage && sessionStorage.clear();
        window.location.href = window.location.origin + "/login";
      }
    });
  };

  componentDidMount = async () => {
    const response = await request(getLandingPageNotifications());
    this.setState({ notifications: response.data.data });
    let url = window.location.pathname;
    const {
      permissionsListing,
      getPermissionsDispatch,
      getUserManualAction,
      getUpcommingAgendaFlagDispatch,
      getBestPracticesCountDispatch
    } = this.props;
    window.addEventListener("resize", this.windowSize);
    this.windowSize();
    if (url === PATHS.HOME) {
      const elem = document.getElementById("root");
      const elemOffSet = elem.offsetTop;
      scrollToPosition({ top: elemOffSet });
      window.addEventListener("scroll", this.handleScroll);
    }
    // get user manual
    isAuthenticated() && getUserManualAction();
    document.addEventListener("click", this.handleClick, false);
    isAuthenticated() &&
      !get(permissionsListing, "status") &&
      getPermissionsDispatch();
    this.resetInactivityTimer();
    axios.interceptors.response.use(res => {
      if (res) {
        this.resetInactivityTimer();
      }
      return res;
    });
    isAuthenticated() && getUpcommingAgendaFlagDispatch();
    getBestPracticesCountDispatch(undefined, {
      groupId: "",
      offset: 0,
      limit: 10,
      search: ""
    }).then(res => {
      this.setState({
        bestPracticesTotalCount: get(res, "data", 0)
      });
    });

    window.addEventListener("toggleDivState", this.handleToggleDivState);
  };

  windowSize = () => {
    const size = window.innerWidth < 992;
    this.setState({ isMobile: size });
  };

  handleToggleDivState = event => {
    this.setState({ underMaintenance: event.detail });
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("click", this.handleClick, false);
    window.removeEventListener("resize", this.windowSize);
    window.removeEventListener("toggleDivState", this.handleToggleDivState);
  }
  componentDidUpdate(prevProps) {
    const { notificationFlag } = this.props;
    if (notificationFlag !== prevProps.notificationFlag) {
      this.setState({ loaderDisplay: notificationFlag });
      setTimeout(() => {
        this.setState({
          notificationOpen: notificationFlag,
          loaderDisplay: false
        });
      }, 3000);
    }
  }
  migrationAPICall = flag => {
    this.props.migrationAPICall(flag);
  };
  handleScroll = () => {
    let url = window.location.pathname;
    if (url === PATHS.HOME) {
      const elem = document.getElementsByTagName("header")[0];
      const height = elem.clientHeight;
      const scrollTop = window.pageYOffset; // window.scrollY or window.pageYOffset
      if (scrollTop >= height) {
        this.setState({ addHeaderClass: "scrolled" });
        if (url === PATHS.HOME) this.makeActiveOnScroll(scrollTop);
      } else {
        this.setState({ addHeaderClass: "" });
      }
    }
  };

  scrollToContainer = id => () => {
    const headerElem = document.getElementsByTagName("header")[0];
    const height = headerElem.clientHeight;
    const elem = document.getElementById(id);
    scrollToPosition({ top: elem.offsetTop - height + 38 });
    this.navToggle();
  };

  makeActiveOnScroll = scrollTop => {
    const elem = document.getElementsByTagName("header")[0];
    const height = elem.clientHeight;
    const { scrollMenu } = this.state;
    let scrollMenuObj = { ...scrollMenu };
    Object.keys(scrollMenuObj).map(elem => {
      let elemPosition = elem && document.getElementById(elem).offsetTop;
      if (scrollTop >= elemPosition - height) {
        this.setState({
          scrollMenu: {
            home: elem === "home" ? true : false,
            "how-it-works": elem === "how-it-works" ? true : false,
            features: elem === "features" ? true : false,
            projects: elem === "projects" ? true : false,
            faq: elem === "faq" ? true : false
          }
        });
      }
      return null;
    });
  };

  getPermissionSingletonObject = () => {
    const { permissionsListing } = this.props;
    if (
      !this.permissions &&
      get(permissionsListing, "status") &&
      isValidArray(get(permissionsListing, "data"))
    ) {
      this.permissionsListing = PERMISSIONS_BY_MODULE(
        get(permissionsListing, "data")
      );
    }
    return this.permissionsListing;
  };

  handleAdminPanel = event => {
    let _isOpen =
      event === "mouseEnter"
        ? true
        : event === "mouseLeave"
        ? false
        : !this.state.isOpen;
    this.setState({ isOpen: _isOpen });
  };

  isNotificationHandleAdmin = event => {
    let _isOpen =
      event === "mouseEnter"
        ? true
        : event === "mouseLeave"
        ? false
        : !this.state.isOpen;
    this.setState({ isNotificationToggle: _isOpen });
  };

  redirectByPermission = permission => {
    const {
      history,
      history: {
        location: { pathname }
      }
    } = this.props;

    const createProjectPermission =
      get(permission, "createProject") &&
      !get(permission, "canViewOnlyProject");
    const user = getLocalstorage("user");
    const agendaPermission =
      get(user, "groupCategory") === "PMG" ||
      get(user, "groupCategory") === "STATE_PMG" ||
      get(user, "groupCategory") === "CENTRAL_DEPARTMENT" ||
      get(user, "groupCategory") === "CENTRAL" ||
      get(user, "groupCategory") === "STATE";
    const adminPermission = get(permission, "admin");
    const groupPermission =
      get(permission, "readGroups") ||
      get(permission, "readGroupRoles") ||
      get(permission, "readUsers") ||
      get(permission, "readRoles");
    const workflowPermission = get(permission, "isWorkflow");
    const misPermission = get(permission, "mis");

    const cmsPermission = get(permission, "cms");

    const URLS_MAP = {
      [PATHS.AGENDA_LIST]: agendaPermission,
      [PATHS.AGENDA_DETAILS]: agendaPermission,
      [PATHS.CREATE_AGENDA]: agendaPermission,
      [PATHS.CREATE_AGENDA]: agendaPermission,
      [PATHS.CREATE_PROJECT]: createProjectPermission,
      [PATHS.GROUP_MANAGEMENT]: adminPermission && groupPermission,
      [PATHS.WORKFLOW]: adminPermission && workflowPermission,
      [PATHS.MIS]: adminPermission && misPermission,
      [PATHS.CMS]: adminPermission && misPermission
    };

    if (
      URLS_MAP.hasOwnProperty(pathname) &&
      permission &&
      !URLS_MAP[pathname]
    ) {
      history.push(PATHS.DASHBOARD);
      return false;
    }
    this.resetInactivityTimer();
  };

  makeActiveUrl = path => {
    const {
      history: {
        location: { pathname }
      }
    } = this.props;
    const regex = RegExp(path, "ig");
    return regex.test(pathname);
  };

  navToggle = () => {
    let { expand } = this.state;
    this.setState({ expand: !expand });
  };

  closeModal = () => {
    this.setState({ isModalVisible: false });
  };

  showModal = key => {
    this.setState({ isModalVisible: true, modalContent: key });
  };

  resetInactivityTimer = () => {
    clearTimeout(this.inactivityTimer);
    this.inactivityTimer = setTimeout(this.logOutUser, this.INACTIVITY_TIMEOUT);
  };
  checkForAR = str => {
    const parts = str.split("-");
    if (parts.length === 2 && parts[1] === "AR") {
      return true;
    }
    return false;
  };
  NameDisplay = userName => {
    const name = "kunderu lakshmi Narasimha Rao";
    if (userName.length >= 15) {
      const secondSpaceIndex = userName.indexOf(" ", userName.indexOf(" ") + 1);

      // Split the name based on the second space index
      const firstName = userName.substring(0, secondSpaceIndex);
      const lastName = userName.substring(secondSpaceIndex + 1);
      return (
        <div>
          <p style={{ marginBottom: "0px", lineHeight: "7px" }}>{firstName}</p>
          <p style={{ marginBottom: "0px" }}>{lastName}</p>
        </div>
      );
    } else {
      return (
        <div>
          <p style={{ marginBottom: "0px", lineHeight: "7px" }}>{userName}</p>
        </div>
      );
    }
  };
  render() {
    const {
      notificationData,
      history,
      userManualDashboard,
      logoutLoading,
      countOfNotViewedStatus,
      upcommingPragatiFlagData,
      notificationFlag,
      taskID,
      toName,
      formName
    } = this.props;
    const {
      notificationOpen,
      addHeaderClass,
      scrollMenu,
      expand,
      modalContent,
      isModalVisible,
      loaderDisplay,
      notifications,
      zoomPercentage
    } = this.state;
    let isLoggedIn = !!getLocalstorage("token");
    const name = getLocalstorage("name");
    const user = getLocalstorage("user");
    const logoDTO = getLocalstorage("logoDTO");
    const logoURL = logoDTO && logoDTO.logo;
    const listOfProject = getLocalstorage("listOfProject");
    const redirectUrl = logoDTO && logoDTO.redirectUrl;
    let url = window.location.pathname;
    const showMenu = !(
      history.location.pathname.includes("/login") ||
      history.location.pathname.includes("/register")
    );
    let permission = null;
    if (isAuthenticated()) {
      permission = this.getPermissionSingletonObject();
      this.redirectByPermission(permission);
    }
    let redirectLink =
      redirectUrl && window.innerWidth > 991
        ? redirectUrl
        : " https://pmgatishakti.gov.in/pmgatishakti/";
    let dpiitLogUrl =
      redirectUrl && window.innerWidth > 991
        ? redirectUrl
        : "https://dpiit.gov.in/";

    let goiLogoUrl = "https://www.india.gov.in/";

    let pmgInvestIndiaMail = isLoggedIn
      ? "pmg@investindia.org.in"
      : "pmg[at]investindia[dot]org[dot]in";
    let pmgSupportMail = isLoggedIn
      ? "pmg-support@investindia.org.in"
      : "pmg-support[at]investindia[dot]org[dot]in";
    const agendaPermission =
      get(user, "groupCategory") === "PMG" ||
      get(user, "groupCategory") === "STATE_PMG" ||
      get(user, "groupCategory") === "CENTRAL_DEPARTMENT" ||
      get(user, "groupCategory") === "CENTRAL" ||
      get(user, "groupCategory") === "STATE";

    const isBestPracticesUrl =
      url === PATHS.BEST_PRACTICES ||
      url.startsWith(PATHS.ARTICLES_DETAILS_PAGE);

    const isAboutUsPage = url.startsWith(PATHS.ABOUT_US_PAGE);
    const isContactUsPage = url.startsWith(PATHS.CONTACT_US_PAGE);
    const isFeedBackPage = url.startsWith(PATHS.FEEDBACK_PAGE);
    const isSiteMap = url.startsWith(PATHS.SITEMAP);
    const usePublicHeader =
      url === PATHS.HOME ||
      isBestPracticesUrl ||
      isAboutUsPage ||
      isContactUsPage ||
      isFeedBackPage ||
      isSiteMap;
    const headerAuthClass =
      isBestPracticesUrl ||
      isAboutUsPage ||
      isContactUsPage ||
      isFeedBackPage ||
      isSiteMap
        ? "logged-out"
        : isLoggedIn
        ? "logged-in"
        : "logged-out";
    const userName = get(user, "name", null);
    return (
      <React.Fragment>
        <ZoomLevelProvider onZoomChange={this.handleZoomChange} />
        <LoaderPage loading={logoutLoading === STATUS.LOADING} />
        {usePublicHeader ? (
          <div
            className={`header-top ${
              isBestPracticesUrl ||
              isAboutUsPage ||
              isContactUsPage ||
              isFeedBackPage ||
              isSiteMap
                ? "best-practices-header"
                : ""
            }`}
          >
            <Container>
              {/* <div className="d-flex">
                <div className="Govt-of-india-logo-alignment">
                  <Row>
                    <a target="_blank" href="https://www.india.gov.in/">
                      <Image src={GoiImage} alt="Government Of India Logo" />
                    </a>
                    <a target="_blank" href="https://commerce.gov.in/">
                      <Image
                        src={MociImage}
                        alt="Commerce And Industry Minsitry"
                      />
                    </a>
                    <a target="_blank" href="https://dpiit.gov.in/">
                      <Image
                        src={DfpImage}
                        alt="Policy And Promotion Minsitry"
                      />
                    </a>
                  </Row>
                </div>
                <div className="toll-no">
                  <img src={IconHelpline} alt="helpline" />
                  <div
                    className="need-help"
                    onClick={() => this.showModal("needHelp")}
                  >
                    Need Help?
                  </div>
                </div>
              </div> */}
            </Container>
          </div>
        ) : null}
        <header
          className={`${headerAuthClass} ${
            window.location.pathname == "/" ? addHeaderClass : ""
          } ${
            isBestPracticesUrl ||
            isAboutUsPage ||
            isContactUsPage ||
            isFeedBackPage ||
            isSiteMap
              ? "best-practices-logout"
              : ""
          } `}
        >
          {" "}
          {/* scrolled */}
          <Navbar
            bg="white"
            expand="lg"
            className="container"
            onToggle={this.navToggle}
            expanded={window.innerWidth <= 991 && expand}
          >
            {showMenu && <Navbar.Toggle aria-controls="basic-navbar-nav" />}
            <div>
              {history.location.pathname !== "/" ? (
                <a
                  target="_blank"
                  href={dpiitLogUrl}
                  className="anchor-tag-with-goi-and-pmgatishakti-logo"
                >
                  {window.innerWidth <= 991 ? (
                    <Image
                      src={GoiLogoResponsive}
                      alt="Government Of India"
                      className={` ${
                        isBestPracticesUrl ||
                        isAboutUsPage ||
                        isContactUsPage ||
                        isFeedBackPage ||
                        isSiteMap
                          ? "d-none"
                          : ""
                      } "goi-logo"`}
                    />
                  ) : isBestPracticesUrl ||
                    isAboutUsPage ||
                    isContactUsPage ||
                    isFeedBackPage ||
                    isSiteMap ? (
                    // <Image
                    //   src={PMGatiShakti1}
                    //   alt="PM GatiShakti"
                    //   className="logo-pmGatishakti mt-0"
                    // />
                    // <Logo
                    //   viewBox="60 0 300 145"
                    //   title=""
                    //   style={{ pointerEvents: "none" }}
                    //   isResponsive={window.innerWidth <= 991}
                    // />
                    <></>
                  ) : logoURL ? (
                    <Image
                      src={
                        get(user, "groupName") ==
                          "Arunachal Pradesh State PMG" ||
                        get(user, "groupName") == "Arunachal Pradesh" ||
                        this.checkForAR(get(user, "groupName"))
                          ? ARlogo
                          : logoURL
                      }
                      alt="Government Logo"
                      style={{
                        marginTop:
                          get(user, "groupName") ==
                            "Arunachal Pradesh State PMG" ||
                          get(user, "groupName") == "Arunachal Pradesh" ||
                          this.checkForAR(get(user, "groupName"))
                            ? -7
                            : null
                      }}
                      className={
                        get(user, "groupName") ==
                          "Arunachal Pradesh State PMG" ||
                        get(user, "groupName") == "Arunachal Pradesh" ||
                        this.checkForAR(get(user, "groupName"))
                          ? null
                          : "government-logo"
                      }
                    />
                  ) : (
                    <React.Fragment>
                      {/* <Image
                        src={LogoDPIIT}
                        alt="Government Of India Logo"
                        className="goi-logo"
                      /> */}
                    </React.Fragment>
                  )}
                </a>
              ) : null}
              {isBestPracticesUrl ||
              isAboutUsPage ||
              isContactUsPage ||
              isFeedBackPage ||
              isSiteMap ||
              history.location.pathname !== "/" ? (
                // <a
                //   href={PATHS.DASHBOARD}
                //   className="anchor-tag-with-goi-and-pmgatishakti-logo"
                // >
                get(user, "groupCategory") === "DISTRICT" ||
                get(user, "groupCategory") === "STATE" ||
                get(user, "groupCategory") === "STATE_PMG" ||
                get(user, "groupCategory") === "STATE_DEPARTMENT" ? (
                  <Link
                    to={
                      isBestPracticesUrl ||
                      isAboutUsPage ||
                      isContactUsPage ||
                      isFeedBackPage ||
                      isSiteMap
                        ? PATHS.HOME
                        : isLoggedIn
                        ? get(user, "groupCategory") !== "PP" ||
                          listOfProject ||
                          get(user, "projectCreatedBy")
                          ? PATHS.DASHBOARD
                          : PATHS.CREATE_PROJECT
                        : PATHS.HOME
                    }
                  >
                    <React.Fragment>
                      <Logo
                        viewBox="60 0 300 145"
                        title=""
                        style={{ pointerEvents: "none" }}
                        marginLeft="true"
                        isResponsive={window.innerWidth <= 991}
                      />
                    </React.Fragment>
                  </Link>
                ) : (
                  <>
                    <Link
                      to={
                        isBestPracticesUrl ||
                        isAboutUsPage ||
                        isContactUsPage ||
                        isFeedBackPage ||
                        isSiteMap
                          ? PATHS.HOME
                          : isLoggedIn
                          ? get(user, "groupCategory") !== "PP" ||
                            listOfProject ||
                            get(user, "projectCreatedBy")
                            ? PATHS.DASHBOARD
                            : PATHS.CREATE_PROJECT
                          : PATHS.HOME
                      }
                    >
                      <React.Fragment>
                        {isLoggedIn && (
                          <Image src={satyamev} style={{ width: "34px" }} />
                        )}
                        <Logo
                          viewBox="60 0 300 145"
                          title=""
                          style={{
                            pointerEvents: "none",
                            marginLeft: !isLoggedIn ? "0px" : "",
                            width: this.width(zoomPercentage)
                          }}
                          isResponsive={window.innerWidth <= 991}
                        />
                      </React.Fragment>
                    </Link>
                    <a target="_blank" href={goiLogoUrl}>
                      {!isLoggedIn && (
                        <Image
                          src={GOIlogoalt}
                          style={{ width: this.width(zoomPercentage) }}
                        />
                      )}
                    </a>
                  </>
                )
              ) : null}
              {/* {(get(user, "groupCategory") === "STATE" ||
                get(user, "groupCategory") === "DISTRICT" ||
                get(user, "groupCategory") === "STATE_PMG" ||
                get(user, "groupCategory") === "STATE_DEPARTMENT") &&
                (get(user, "groupName")
                  .toLowerCase()
                  .includes("delhi") ||
                  get(user, "groupName").includes("-DL")) &&
                window.innerWidth >= 991 && (
                  <div className="cm-pragati-text">DELHI CM-PRAGATI</div>
                )} */}
            </div>
            {/* {(get(user, "groupCategory") === "STATE" ||
              get(user, "groupCategory") === "DISTRICT" ||
              get(user, "groupCategory") === "STATE_PMG" ||
              get(user, "groupCategory") === "STATE_DEPARTMENT") &&
              (get(user, "groupName")
                .toLowerCase()
                .includes("delhi") ||
                get(user, "groupName").includes("-DL")) &&
              window.innerWidth <= 991 && (
                <div className="cm-pragati-text-mobile-view">
                  DELHI CM-PRAGATI
                </div>
              )} */}
            {/* not render */}
            {history.location.pathname !== "/" ? (
              <a
                target="_blank"
                href={redirectLink}
                className="anchor-tag-with-goi-and-pmgatishakti-logo"
              >
                {window.innerWidth <= 991 ? null : isBestPracticesUrl ||
                  isAboutUsPage ||
                  isContactUsPage ||
                  isFeedBackPage ||
                  isSiteMap ? (
                  // <Image
                  //   src={PMGatiShakti1}
                  //   alt="PM GatiShakti"
                  //   className="logo-pmGatishakti mt-0"
                  // />
                  <></>
                ) : (
                  // <Logo
                  //   viewBox="60 0 300 145"
                  //   title=""
                  //   style={{ pointerEvents: "none" }}
                  //   isResponsive={window.innerWidth <= 991}
                  // />
                  <React.Fragment>
                    {/* <Image
                      src={Goilogo}
                      alt="Government Of India Logo"
                      className="goi-logo"
                    /> */}
                  </React.Fragment>
                )}
              </a>
            ) : null}

            {!isBestPracticesUrl ||
            (!isAboutUsPage ||
              (!isContactUsPage &&
                (isLoggedIn || (!isLoggedIn && window.innerWidth >= 991)))) ? (
              get(user, "groupCategory") === "CENTRAL" ||
              get(user, "groupCategory") === "PP" ||
              get(user, "groupCategory") === "CENTRAL_DEPARTMENT" ||
              get(user, "groupCategory") === "OTHER" ||
              get(user, "groupCategory") === "DISTRICT" ||
              get(user, "groupCategory") === "STATE" ? (
                <Navbar.Brand className="navbar-brand-2">
                  {history.location.pathname === PATHS.HOME &&
                  addHeaderClass !== "scrolled" ? (
                    // <Image
                    //   src={PMGatiShakti2}
                    //   alt="PM GatiShakti"
                    //   className="mt-n1"
                    // />
                    <span style={{ position: "relative", right: "20px" }}>
                      <Link>
                        <LogoSvgWhite style={{ Cursor: "pointer" }} />
                      </Link>
                    </span>
                  ) : null}
                  {history.location.pathname === "/" ? (
                    addHeaderClass === "scrolled" ? (
                      <>
                        <Logo
                          title=""
                          className="logo-pmGatishakti mt-0"
                          viewBox="60 0 350 170"
                          style={{
                            width: "110px",
                            height: "56px",
                            pointerEvents: "none"
                          }}
                          noneClass={window.innerWidth <= 991}
                        />
                        {/* <Image
                          src={PMGatiShakti1}
                          alt="PM GatiShakti"
                          className="mr-3"
                          style={{
                            width: "110px",
                            height: "56px",
                            pointerEvents: "none"
                          }}
                        /> */}
                      </>
                    ) : null
                  ) : null}

                  <a
                    target="_blank"
                    href={redirectLink}
                    className="anchor-tag-with-goi-and-pmgatishakti-logo"
                  >
                    {history.location.pathname === "/" ? (
                      addHeaderClass === "scrolled" ? (
                        // <>
                        //   <Logo
                        //     title=""
                        //     className="logo-pmGatishakti mt-0"
                        //     viewBox="60 0 350 170"
                        //     style={{
                        //       width: "110px",
                        //       height: "56px",
                        //       pointerEvents: "none"
                        //     }}
                        //     noneClass={window.innerWidth <= 991}
                        //   />
                        //   <Image
                        //     src={PMGatiShakti1}
                        //     alt="PM GatiShakti"
                        //     className="mr-3"
                        //     style={{
                        //       width: "110px",
                        //       height: "56px",
                        //       pointerEvents: "none"
                        //     }}
                        //   />
                        // </>
                        <></>
                      ) : window.innerWidth <= 991 ? (
                        // <Logo
                        //   viewBox="60 0 300 145"
                        //   title=""
                        //   style={{
                        //     pointerEvents: "none",
                        //     width: "110px",
                        //     height: "56px",
                        //     "margin-left": "15px"
                        //   }}
                        //   isResponsive={window.innerWidth <= 991}
                        // />
                        <></>
                      ) : (
                        // <LogoSvgWhite style={{ pointerEvents: "none" }} />
                        // <span style={{ position: "relative", right: "25px" }}>
                        //   <Image
                        //     src={PMGatiShakti2}
                        //     alt="PM GatiShakti"
                        //     className="mt-n1"
                        //   />
                        // </span>
                        <></>
                      )
                    ) : get(user, "groupCategory") === "PMG" ||
                      get(user, "groupCategory") === "CENTRAL" ||
                      get(user, "groupCategory") === "PP" ||
                      get(user, "groupCategory") === "CENTRAL_DEPARTMENT" ||
                      get(user, "groupCategory") === "OTHER" ? (
                      // <Image
                      //   src={PMGatiShakti1}
                      //   alt="PM GatiShakti"
                      //   className="logo-pmGatishakti mt-0"
                      // />
                      <></>
                    ) : (
                      //  <Image
                      //  src={PMGatiShakti1}
                      //     alt="PM GatiShakti"
                      //     className="logo-pmGatishakti mt-0"
                      //   />
                      // <Logo
                      //   viewBox="60 0 300 145"
                      //   title=""
                      //   marginLeft="true"
                      //   style={{ pointerEvents: "none" }}
                      //   isResponsive={window.innerWidth <= 991}
                      // />
                      <></>
                    )}
                  </a>
                </Navbar.Brand>
              ) : (
                <Navbar.Brand className="navbar-brand-1">
                  {history.location.pathname === PATHS.HOME &&
                  addHeaderClass !== "scrolled" ? (
                    // <Image
                    //   src={PMGatiShakti2}
                    //   alt="PM GatiShakti"
                    //   className="mt-n1"
                    // />
                    <>
                      <span
                        style={{
                          marginLeft: "5px"
                        }}
                      >
                        <Link to="/">
                          <LogoSvgWhite
                            style={{
                              cursor: "pointer",
                              width: this.width(zoomPercentage)
                            }}
                          />
                        </Link>
                      </span>
                      <span>
                        <a target="_blank" href={goiLogoUrl}>
                          <Image
                            src={GOIlogo}
                            style={{
                              width: this.width(zoomPercentage),
                              marginLeft: "25px"
                            }}
                          />
                        </a>
                      </span>
                    </>
                  ) : null}
                  {history.location.pathname === "/" ? (
                    addHeaderClass === "scrolled" ? (
                      <>
                        <Logo
                          title=""
                          className="logo-pmGatishakti mt-0"
                          viewBox="60 0 350 170"
                          style={{
                            width: "100px",
                            pointerEvents: "none",
                            marginLeft: "-2px"
                          }}
                          noneClass={window.innerWidth <= 991}
                        />
                        <Image
                          src={GOIlogoalt}
                          style={{
                            width: "90px",
                            height: "35px",
                            marginLeft: "-10px"
                          }}
                        />
                        {/* <Image
                          src={PMGatiShakti1}
                          alt="PM GatiShakti"
                          className="mr-3"
                          style={{
                            width: "110px",
                            height: "56px",
                            pointerEvents: "none"
                          }}
                        /> */}
                      </>
                    ) : null
                  ) : null}

                  <a
                    target="_blank"
                    href={redirectLink}
                    className="anchor-tag-with-goi-and-pmgatishakti-logo"
                  >
                    {history.location.pathname === "/" ? (
                      addHeaderClass === "scrolled" ? (
                        // <>
                        //   <Logo
                        //     title=""
                        //     className="logo-pmGatishakti mt-0"
                        //     viewBox="60 0 350 170"
                        //     style={{
                        //       width: "110px",
                        //       height: "56px",
                        //       pointerEvents: "none"
                        //     }}
                        //     noneClass={window.innerWidth <= 991}
                        //   />
                        //   <Image
                        //     src={PMGatiShakti1}
                        //     alt="PM GatiShakti"
                        //     className="mr-3"
                        //     style={{
                        //       width: "110px",
                        //       height: "56px",
                        //       pointerEvents: "none"
                        //     }}
                        //   />
                        // </>
                        <></>
                      ) : window.innerWidth <= 991 ? (
                        // <Logo
                        //   viewBox="60 0 300 145"
                        //   title=""
                        //   style={{
                        //     pointerEvents: "none",
                        //     width: "110px",
                        //     height: "56px",
                        //     "margin-left": "15px"
                        //   }}
                        //   isResponsive={window.innerWidth <= 991}
                        // />
                        <></>
                      ) : (
                        // <LogoSvgWhite style={{ pointerEvents: "none" }} />
                        // <span style={{ position: "relative", right: "25px" }}>
                        //   <Image
                        //     src={PMGatiShakti2}
                        //     alt="PM GatiShakti"
                        //     className="mt-n1"
                        //   />
                        // </span>
                        <></>
                      )
                    ) : get(user, "groupCategory") === "PMG" ||
                      get(user, "groupCategory") === "CENTRAL" ||
                      get(user, "groupCategory") === "PP" ||
                      get(user, "groupCategory") === "CENTRAL_DEPARTMENT" ||
                      get(user, "groupCategory") === "OTHER" ? (
                      // <Image
                      //   src={PMGatiShakti1}
                      //   alt="PM GatiShakti"
                      //   className="logo-pmGatishakti mt-0"
                      // />
                      <></>
                    ) : (
                      //  <Image
                      //  src={PMGatiShakti1}
                      //     alt="PM GatiShakti"
                      //     className="logo-pmGatishakti mt-0"
                      //   />
                      // <Logo
                      //   viewBox="60 0 300 145"
                      //   title=""
                      //   marginLeft="true"
                      //   style={{ pointerEvents: "none" }}
                      //   isResponsive={window.innerWidth <= 991}
                      // />
                      <></>
                    )}
                  </a>
                </Navbar.Brand>
              )
            ) : null}

            {isLoggedIn ? (
              <div className="menu-wrapper">
                {window.innerWidth <= 991 && expand === true && (
                  <div className="close-navbar" onClick={this.navToggle} />
                )}
                <Navbar.Collapse
                  id="basic-navbar-nav"
                  className="justify-content-end"
                >
                  <div className="menu">
                    <div className="menu-inner">
                      {window.innerWidth > 991 && (
                        <div className="menu-header">
                          <Navbar.Brand href={PATHS.HOME}>
                            <Logo />
                          </Navbar.Brand>
                          <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        </div>
                      )}
                      {window.innerWidth <= 991 && (
                        <div className="navprofile-dropdown">
                          <Dropdown as={NavItem}>
                            <Dropdown.Toggle>
                              <div className="avatar">
                                {/* <img src={ministry} width={42} /> */}
                                <img src={pmgUser} width={42} alt={name} />
                              </div>
                              <div className="user-name" data-test="user-name">
                                <b>{get(user, "groupCode", null)}</b>
                                {get(user, "name", null)}
                              </div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-animate slideDownIn">
                              <NavItem onClick={this.navToggle}>
                                <Link
                                  to={PATHS.PROFILE}
                                  className="dropdown-item"
                                >
                                  Profile
                                </Link>
                              </NavItem>
                              <NavItem onClick={this.navToggle}>
                                <Link
                                  to={PATHS.CHANGE_PASSWORD}
                                  className="dropdown-item"
                                >
                                  Change Password
                                </Link>
                              </NavItem>
                              <NavItem onClick={this.navToggle}>
                                <Link
                                  //to={PATHS.LOGIN}
                                  onClick={this.logOutUser}
                                  className="dropdown-item"
                                  data-test="dropdown-logout"
                                >
                                  Logout
                                </Link>
                              </NavItem>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      )}

                      {get(user, "groupCategory") !== "PP" ||
                      get(user, "projectCreatedBy") ||
                      listOfProject ? (
                        <Nav activeKey={PATHS.DASHBOARD} className="mr-auto">
                          <DisplayByPermission display={permission && true}>
                            <NavItem onClick={this.navToggle}>
                              <NavLink
                                to={PATHS.DASHBOARD}
                                className={`icon-speedometer nav-link ${this.makeActiveUrl(
                                  PATHS.DASHBOARD
                                ) && "active"}`}
                              >
                                Dashboard
                              </NavLink>
                            </NavItem>
                          </DisplayByPermission>
                          <DisplayByPermission display={permission && true}>
                            <NavItem onClick={this.navToggle}>
                              <NavLink
                                to={PATHS.PROJECT_LIST}
                                className={`icon-rocket nav-link ${(this.makeActiveUrl(
                                  PATHS.PROJECT_DETAILS
                                ) ||
                                  this.makeActiveUrl(PATHS.CREATE_PROJECT)) &&
                                  "active"}`}
                                data-test="projects-tab"
                              >
                                Projects
                              </NavLink>
                            </NavItem>
                          </DisplayByPermission>
                          <DisplayByPermission display={permission && true}>
                            <NavItem onClick={this.navToggle}>
                              <NavLink
                                to={PATHS.ISSUE_LIST}
                                className={`icon-grid nav-link ${(this.makeActiveUrl(
                                  PATHS.ISSUE_LIST
                                ) ||
                                  this.makeActiveUrl(PATHS.ISSUE_DETAIL)) &&
                                  "active"}`}
                                data-test="issues-tab"
                              >
                                Issues
                              </NavLink>
                            </NavItem>
                          </DisplayByPermission>
                          <DisplayByPermission display={true}>
                            <NavItem onClick={this.navToggle}>
                              <NavLink
                                to={PATHS.PRAGATI_LISTING_PAGE}
                                className={`nav-link icon-agenda icon-pragati ${(this.makeActiveUrl(
                                  PATHS.PRAGATI_DETAILS_PAGE
                                ) ||
                                  this.makeActiveUrl(
                                    PATHS.PRAGATI_LISTING_PAGE
                                  )) &&
                                  "active"}`}
                              >
                                PRAGATI
                                {upcommingPragatiFlagData &&
                                  upcommingPragatiFlagData.hasScheduledMeetings && (
                                    <span className="upcomming-pragati-flag">
                                      <img
                                        src={upcomming_pragati_flagIcon}
                                        alt="upcomming_pragati"
                                      />
                                    </span>
                                  )}
                              </NavLink>
                            </NavItem>
                          </DisplayByPermission>
                          <DisplayByPermission display={agendaPermission}>
                            <NavItem onClick={this.navToggle}>
                              <NavLink
                                to={
                                  window.location.pathname === "/mis" ||
                                  window.location.pathname ===
                                    "/user-management"
                                    ? { pathname: PATHS.AGENDA_LIST }
                                    : PATHS.AGENDA_LIST
                                }
                                target={
                                  window.location.pathname === "/mis" ||
                                  window.location.pathname ===
                                    "/user-management"
                                    ? "_parent"
                                    : undefined
                                }
                                className={`nav-link icon-agenda ${(this.makeActiveUrl(
                                  PATHS.AGENDA_DETAILS
                                ) ||
                                  this.makeActiveUrl(PATHS.CREATE_AGENDA) ||
                                  this.makeActiveUrl(PATHS.AGENDA_LIST)) &&
                                  "active"}`}
                              >
                                Agenda
                              </NavLink>
                            </NavItem>
                          </DisplayByPermission>
                          <DisplayByPermission
                            display={get(permission, "admin")}
                          >
                            <NavDropdown
                              title="Admin"
                              id="basic-nav-dropdown"
                              onMouseEnter={() =>
                                window.innerWidth > 991 &&
                                this.handleAdminPanel("mouseEnter")
                              }
                              onMouseLeave={() =>
                                this.handleAdminPanel("mouseLeave")
                              }
                              onToggle={
                                window.innerWidth <= 991 &&
                                this.handleAdminPanel
                              }
                              show={this.state.isOpen}
                              className={`admin-icon-wrapper ${(this.makeActiveUrl(
                                PATHS.MIS
                              ) ||
                                this.makeActiveUrl(PATHS.GROUP_MANAGEMENT) ||
                                this.makeActiveUrl(PATHS.CMS) ||
                                this.makeActiveUrl(PATHS.WORKFLOW)) &&
                                "active"}`}
                            >
                              <div className="dropdown-animate slideDownIn">
                                <DisplayByPermission
                                  display={
                                    get(permission, "readGroups") ||
                                    get(permission, "readGroupRoles") ||
                                    get(permission, "readUsers") ||
                                    get(permission, "readRoles")
                                  }
                                >
                                  <NavItem
                                    onClick={this.navToggle}
                                    className="group-management pb-1"
                                  >
                                    <NavLink
                                      to={PATHS.GROUP_MANAGEMENT}
                                      className={`dropdown-item ${this.makeActiveUrl(
                                        PATHS.GROUP_MANAGEMENT
                                      ) && "active"}`}
                                    >
                                      User Management
                                    </NavLink>
                                  </NavItem>
                                </DisplayByPermission>
                                <DisplayByPermission
                                  display={get(permission, "mis")}
                                >
                                  <NavItem onClick={this.navToggle}>
                                    <NavLink
                                      to={PATHS.MIS}
                                      className="dropdown-item"
                                    >
                                      MIS
                                    </NavLink>
                                  </NavItem>
                                </DisplayByPermission>
                                <DisplayByPermission
                                  display={get(permission, "mis")}
                                >
                                  <NavItem onClick={this.navToggle}>
                                    <NavLink
                                      to={PATHS.CMS}
                                      className="dropdown-item"
                                    >
                                      CMS
                                    </NavLink>
                                  </NavItem>
                                </DisplayByPermission>
                              </div>
                            </NavDropdown>
                          </DisplayByPermission>
                        </Nav>
                      ) : null}
                      <DisplayByPermission display={permission}>
                        <div className="tollfree-number-mob">
                          <img src={IconHelpline} alt="helpline" />
                          <div
                            className="need-help"
                            onClick={() => this.showModal("needHelp")}
                          >
                            Need Help?
                          </div>
                        </div>
                      </DisplayByPermission>
                    </div>
                  </div>
                </Navbar.Collapse>
                <ul className="nav-profile">
                  <DisplayByPermission display={permission}>
                    <li className="tollfree-number">
                      <img src={IconHelpline} alt="helpline" />
                      <div
                        className="need-help"
                        onClick={() => this.showModal("needHelp")}
                      >
                        Need Help?
                      </div>
                    </li>
                  </DisplayByPermission>
                  <DisplayByPermission display={permission}>
                    <li>
                      <div>
                        <span
                          className={`notification-tab`}
                          onClick={this.notificationClick}
                        >
                          <NotificationLoaderPage loading={loaderDisplay} />
                          <img src={IconNotification} alt="notification" />
                          <img
                            src={LoaderGif}
                            className="notification-loader"
                            style={{ display: loaderDisplay ? null : "none" }}
                          />
                          {countOfNotViewedStatus ? (
                            <div className="notification">
                              {countOfNotViewedStatus}
                            </div>
                          ) : null}
                        </span>
                      </div>
                      <DisplayByPermission
                        display={
                          get(permission, "enableDisableNotification") &&
                          !get(permission, "canViewOnlyProject")
                        }
                      >
                        <NotificationToggle />
                      </DisplayByPermission>
                    </li>
                  </DisplayByPermission>
                  {window.innerWidth > 991 && (
                    <li className="dropdown-toggle profile-dropdown">
                      <Dropdown as={NavItem}>
                        <Dropdown.Toggle>
                          <div className="avatar">
                            {/* <img src={ministry} width={42} /> */}
                            <img src={pmgUser} width={42} alt={name} />
                          </div>
                          <div
                            className="profile-name"
                            data-test="profile-name"
                          >
                            <b>{get(user, "groupCode", null)}</b>
                            {/* {get(user, "name", null)} */}
                            {this.NameDisplay(userName)}
                          </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Link to={PATHS.PROFILE} className="dropdown-item">
                            Profile
                          </Link>
                          {userManualDashboard.downloadingSrc ? (
                            <a
                              className="dropdown-item"
                              href={userManualDashboard.downloadingSrc}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              User Manual
                            </a>
                          ) : null}
                          <Link to={PATHS.GET_OTP} className="dropdown-item">
                            Change Password
                          </Link>
                          <Link
                            //to={PATHS.LOGIN}
                            onClick={this.logOutUser}
                            className="dropdown-item"
                            data-test="dropdown-logout"
                          >
                            Logout
                          </Link>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  )}
                </ul>
              </div>
            ) : usePublicHeader ? (
              <div className="menu-wrapper">
                {window.innerWidth <= 991 && expand === true && (
                  <div className="close-navbar" onClick={this.navToggle} />
                )}
                <Navbar.Collapse
                  id="basic-navbar-nav"
                  className="justify-content-end"
                >
                  <div className="menu">
                    <div className="menu-inner">
                      <div className="menu-header">
                        <Navbar.Brand href={PATHS.HOME}>
                          <Logo />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                      </div>
                      <Nav
                        defaultActiveKey={PATHS.HOME}
                        style={{ fontSize: 13.5 }}
                      >
                        <Nav.Link
                          eventKey="home"
                          href={
                            isBestPracticesUrl ||
                            isAboutUsPage ||
                            isContactUsPage ||
                            isFeedBackPage ||
                            isSiteMap
                              ? PATHS.HOME
                              : ""
                          }
                          onClick={this.scrollToContainer("home")}
                          className={`${
                            isBestPracticesUrl ||
                            isAboutUsPage ||
                            isContactUsPage ||
                            isFeedBackPage ||
                            isSiteMap
                              ? "best-practices-link"
                              : ""
                          } ${
                            scrollMenu.home &&
                            !isBestPracticesUrl &&
                            !isAboutUsPage &&
                            !isContactUsPage &&
                            !isFeedBackPage &&
                            !isSiteMap
                              ? "active"
                              : ""
                          }`}
                          data-test="home-tab"
                        >
                          Home
                        </Nav.Link>
                        <Nav.Link
                          eventKey="about-us"
                          as={Link}
                          to={PATHS.ABOUT_US_PAGE}
                          className={`${
                            isBestPracticesUrl || isAboutUsPage
                              ? "best-practices-link"
                              : ""
                          } ${isAboutUsPage ? "active" : ""}`}
                          data-test="about-us-tab"
                        >
                          About Us
                        </Nav.Link>
                        {/* <Nav.Link
                          eventKey="how-it-works"
                          href={
                            isBestPracticesUrl || isAboutUsPage
                              ? PATHS.HOME
                              : ""
                          }
                          onClick={this.scrollToContainer("how-it-works")}
                          className={`${
                            isBestPracticesUrl ? "best-practices-link" : ""
                          } ${scrollMenu["how-it-works"] ? "active" : ""}`}
                          data-test="how-it-works-tab"
                        >
                          How it Works
                        </Nav.Link>
                        <Nav.Link
                          eventKey="features"
                          href={
                            isBestPracticesUrl || isAboutUsPage
                              ? PATHS.HOME
                              : ""
                          }
                          onClick={this.scrollToContainer("features")}
                          className={`${
                            isBestPracticesUrl ? "best-practices-link" : ""
                          } ${scrollMenu.features ? "active" : ""}`}
                          data-test="features-tab"
                        >
                          Features
                        </Nav.Link> */}
                        <NavDropdown
                          data-test="overview-tab"
                          title="Overview"
                          id={
                            isBestPracticesUrl
                              ? "best-practices-overview-dropdown-link"
                              : "overview-nav-dropdown"
                          }
                          onMouseEnter={() =>
                            window.innerWidth > 991 &&
                            this.handleOverviewPanel("mouseEnter")
                          }
                          onMouseLeave={() =>
                            this.handleOverviewPanel("mouseLeave")
                          }
                          onToggle={
                            window.innerWidth <= 991 && this.handleOverviewPanel
                          }
                          show={this.state.isOverviewOpen}
                        >
                          <div className="dropdown-animate">
                            <div
                              className="nav-item"
                              style={{ paddingTop: "3px" }}
                            >
                              <a
                                className={`manual-wrapper dropdown-item ${
                                  scrollMenu["how-it-works"] ? "active" : ""
                                }`}
                                href={
                                  isBestPracticesUrl ||
                                  isAboutUsPage ||
                                  isContactUsPage
                                    ? PATHS.HOME
                                    : ""
                                }
                                onClick={e => {
                                  if (
                                    !(
                                      isBestPracticesUrl ||
                                      isAboutUsPage ||
                                      isContactUsPage
                                    )
                                  ) {
                                    e.preventDefault();
                                  }
                                  this.scrollToContainer("how-it-works")(e);
                                  this.setState({ isOverviewOpen: false });
                                }}
                                data-test="how-it-works-tab"
                              >
                                How it Works
                              </a>
                            </div>

                            <div className="nav-item">
                              <a
                                className={`manual-wrapper dropdown-item ${
                                  scrollMenu.features ? "active" : ""
                                }`}
                                href={
                                  isBestPracticesUrl ||
                                  isAboutUsPage ||
                                  isContactUsPage
                                    ? PATHS.HOME
                                    : ""
                                }
                                onClick={e => {
                                  if (
                                    !(isBestPracticesUrl || isAboutUsPage) ||
                                    (isBestPracticesUrl || isContactUsPage)
                                  ) {
                                    e.preventDefault();
                                  }
                                  this.scrollToContainer("features")(e);
                                  this.setState({ isOverviewOpen: false });
                                }}
                                data-test="features-tab"
                              >
                                Features
                              </a>
                            </div>
                          </div>
                        </NavDropdown>
                        <Nav.Link
                          eventKey="projects"
                          href={
                            isBestPracticesUrl ||
                            isAboutUsPage ||
                            isContactUsPage
                              ? PATHS.HOME
                              : ""
                          }
                          onClick={this.scrollToContainer("projects")}
                          className={`${
                            isBestPracticesUrl ? "best-practices-link" : ""
                          } ${
                            scrollMenu.projects &&
                            !isAboutUsPage &&
                            !isContactUsPage
                              ? "active"
                              : ""
                          }`}
                          data-test="projects-tab"
                        >
                          Projects
                        </Nav.Link>
                        {/*<Nav.Link href="#link">Feedback</Nav.Link>*/}
                        <Nav.Link
                          eventKey="faq"
                          href={
                            isBestPracticesUrl ||
                            isAboutUsPage ||
                            isContactUsPage
                              ? PATHS.HOME
                              : ""
                          }
                          onClick={this.scrollToContainer("faq")}
                          className={`${
                            isBestPracticesUrl ? "best-practices-link" : ""
                          } ${
                            scrollMenu.faq && !isAboutUsPage && !isContactUsPage
                              ? "active"
                              : ""
                          }`}
                          data-test="faq-tab"
                        >
                          FAQs
                        </Nav.Link>
                        <NavDropdown
                          data-test="resources-tab"
                          title="Resources"
                          id={`${
                            isBestPracticesUrl
                              ? "best-practices-dropdown-link"
                              : "basic-nav-dropdown"
                          }`}
                          onMouseEnter={() =>
                            window.innerWidth > 991 &&
                            this.handleAdminPanel("mouseEnter")
                          }
                          onMouseLeave={() =>
                            this.handleAdminPanel("mouseLeave")
                          }
                          onToggle={
                            window.innerWidth <= 991 && this.handleAdminPanel
                          }
                          show={this.state.isOpen}
                        >
                          <div className="dropdown-animate ">
                            <div
                              className="nav-item"
                              style={{
                                paddingTop: "3px",
                                paddingBottom:
                                  this.state.bestPracticesTotalCount > 0
                                    ? "7px"
                                    : undefined
                              }}
                            >
                              <a
                                className="best-practice-header manual-wrapper dropdown-item"
                                href="https://ora.ox.ac.uk/objects/uuid:34268453-91fb-4dd3-b052-90fbb52fe247/files/s1j92g9820"
                                target="_blank"
                                data-test="best-practices"
                              >
                                PRAGATI Oxford Report
                              </a>
                            </div>
                            {this.state.bestPracticesTotalCount > 0 && (
                              <NavItem onClick={this.navToggle}>
                                <NavLink
                                  to={PATHS.BEST_PRACTICES}
                                  href={PATHS.BEST_PRACTICES}
                                  target="_blank"
                                  className="best-practice-header manual-wrapper dropdown-item"
                                  data-test="best-practices"
                                >
                                  Best Practices
                                </NavLink>
                              </NavItem>
                            )}

                            <NavDropdown
                              title="Notifications"
                              id={
                                isBestPracticesUrl ||
                                isAboutUsPage ||
                                isContactUsPage ||
                                url === PATHS.HOME
                                  ? "best-practices-notification-nav-dropdown"
                                  : "notification-nav-dropdown"
                              }
                              class="notification-dropdown-toggle nav-link"
                              onMouseEnter={() =>
                                window.innerWidth > 991 &&
                                this.isNotificationHandleAdmin("mouseEnter")
                              }
                              onMouseLeave={() =>
                                this.isNotificationHandleAdmin("mouseLeave")
                              }
                              onToggle={
                                window.innerWidth <= 991 &&
                                this.handleAdminPanel
                              }
                              show={this.state.isNotificationToggle}
                            >
                              {notifications.map(item => {
                                // Safely get PDF URL
                                const fileUrl =
                                  Array.isArray(item.file) &&
                                  item.file.length > 0
                                    ? item.file[0].s3Url
                                    : null;

                                // Skip if no file
                                if (!fileUrl) return null;

                                return (
                                  <div className="nav-item" key={item.id}>
                                    <a
                                      className="pdf-wrapper manual-wrapper dropdown-item"
                                      href={fileUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-test={`notification-${item.id}`}
                                    >
                                      {item.title}
                                    </a>
                                  </div>
                                );
                              })}
                            </NavDropdown>
                          </div>
                        </NavDropdown>
                        <Nav.Link
                          eventKey="contact-us"
                          as={Link}
                          to={PATHS.CONTACT_US_PAGE}
                          className={`${
                            isContactUsPage ? "best-practices-link active" : ""
                          }`}
                          data-test="contact-us-tab"
                        >
                          Contact Us
                        </Nav.Link>
                      </Nav>
                      <ul className="nav-login mob">
                        <li>
                          <Link
                            to={PATHS.LOGIN}
                            className={` ${
                              isBestPracticesUrl || isAboutUsPage
                                ? "best-practices-link"
                                : "btn btn-blue-invert"
                            } no-padding login-button`}
                            data-test="login"
                          >
                            Login
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={PATHS.SIGNUP}
                            className="btn btn-pink no-padding"
                            data-test="register"
                          >
                            Register
                          </Link>
                        </li>
                      </ul>
                      <div className="tollfree-number-mob">
                        <img src={IconHelpline} alt="helpline" />
                        <div
                          className="need-help"
                          onClick={() => this.showModal("needHelp")}
                        >
                          Need Help?
                        </div>
                      </div>
                    </div>
                  </div>
                </Navbar.Collapse>
                <ul className="nav-login">
                  <li>
                    <Link
                      to={PATHS.LOGIN}
                      className={` ${
                        isBestPracticesUrl ||
                        isAboutUsPage ||
                        isContactUsPage ||
                        isFeedBackPage ||
                        isSiteMap
                          ? "best-practices-link"
                          : ""
                      } btn btn-blue-invert no-padding login-button`}
                      data-test="login-link"
                      id={`${
                        isBestPracticesUrl ||
                        isAboutUsPage ||
                        isContactUsPage ||
                        isFeedBackPage ||
                        isSiteMap
                          ? "best-practices-link"
                          : ""
                      }`}
                    >
                      Login
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={PATHS.SIGNUP}
                      className="btn btn-pink no-padding"
                      data-test="register-button"
                    >
                      Register
                    </Link>
                  </li>
                </ul>
              </div>
            ) : null}

            {history.location.pathname === "/" ||
            isBestPracticesUrl ||
            isAboutUsPage ||
            isContactUsPage ? (
              window.innerWidth <= 991 ? (
                <Image
                  src={GoiLogoResponsive}
                  alt="Government Of India"
                  className="goi-logo home-screen-goi-logo"
                />
              ) : null
            ) : null}
            {!isLoggedIn && window.innerWidth <= 991 ? (
              <Navbar.Brand>
                <Link
                  to={
                    isLoggedIn
                      ? get(user, "groupCategory") !== "PP" ||
                        listOfProject ||
                        get(user, "projectCreatedBy")
                        ? PATHS.DASHBOARD
                        : PATHS.CREATE_PROJECT
                      : PATHS.HOME
                  }
                >
                  {history.location.pathname === "/" ? (
                    addHeaderClass === "scrolled" ? (
                      <Logo
                        title=""
                        viewBox="60 0 350 170"
                        style={{
                          width: "110px",
                          height: "56px",
                          pointerEvents: "none"
                        }}
                        noneClass={window.innerWidth <= 991}
                      />
                    ) : window.innerWidth <= 991 ? (
                      <Logo
                        viewBox="60 0 300 145"
                        title=""
                        style={{
                          pointerEvents: "none",
                          width: "110px",
                          height: "56px",
                          "margin-left": "15px"
                        }}
                        isResponsive={window.innerWidth <= 991}
                      />
                    ) : (
                      <LogoSvgWhite style={{ pointerEvents: "none" }} />
                    )
                  ) : (
                    <Logo
                      viewBox="60 0 300 145"
                      title=""
                      style={{ pointerEvents: "none" }}
                      isResponsive={window.innerWidth <= 991}
                    />
                  )}
                </Link>
              </Navbar.Brand>
            ) : null}
          </Navbar>
          {isLoggedIn ? (
            <Notification
              placement="header"
              notificationOpen={notificationOpen}
              notificationClick={this.notificationClick}
              notifyData={notificationData}
              notificationFlag={notificationFlag}
              taskID={taskID}
              migrationAPICall={this.migrationAPICall}
              formName={formName}
              toName={toName}
            />
          ) : null}
          {modalContent === "needHelp" ? (
            <NeedHelpModal
              show={isModalVisible}
              closeModal={this.closeModal}
              pmgInvestIndiaMail={pmgInvestIndiaMail}
              pmgSupportMail={pmgSupportMail}
            />
          ) : null}
        </header>
      </React.Fragment>
    );
  }
}

HeaderComponent.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.shape({}),
  toggleSideBarDispatch: PropTypes.func,
  toggleSideBar: PropTypes.bool,
  history: PropTypes.shape({}),
  location: PropTypes.shape({})
};

HeaderComponent.defaultProps = {
  className: "",
  theme: {},
  toggleSideBarDispatch: () => {},
  toggleSideBar: false,
  history: {},
  location: {}
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    toggleSideBar: state.commonReducer.toggleSideBar,
    projectList: state.commonReducer.projectList,
    loginResult: state.loginReducer.data,
    logoutLoading: state.loginReducer.logoutStatus,
    notificationData: state.dashboardReducer.notificationData,
    countOfNotViewedStatus: state.dashboardReducer.countOfNotViewedStatus,
    permissionsListing: state.commonReducer.permissionsListing,
    userManualDashboard: state.donwloadExcelReducer.userManualDashboard,
    upcommingPragatiFlagData: state.pragatiReducer.upcommingPragatiFlagData
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleSideBarDispatch: toggleSidebar,
      getPermissionsDispatch: getPermissionsAction,
      getDashboardNotifications,
      clearPermissionsDispatch: clearPermissionsList,
      getUserManualAction,
      _userLogout,
      getNotificationUpdates,
      getUpcommingAgendaFlagDispatch: getUpcommingAgendaFlagAction,
      getBestPracticesCountDispatch: getBestPracticesCountForHome
    },
    dispatch
  );
}

export const Header = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HeaderComponent));
